import React from 'react'

const ContactScreen = () => {
  return (
    <div>ContactScreen</div>
  )
}

export default ContactScreen